// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"d8-z"};